import type {
  AllowedFacetConditionOperator,
  FacetConditionOperator,
  FacetKey,
  FilterCondition,
} from '@/features/analyze/types';

// ファセットキーが追加/変更/削除されたらここに追加する
const PREFERRED_OPERATORS = {
  topicTags: 'and',
  themes: 'and',
  countries: 'or',
  organizations: 'or',
  organizationTypes: 'or',
  countryTags: 'or',
} as const satisfies { [K in FacetKey]: FacetConditionOperator<K> };

/**
 * MEMO:
 * 引数と同じkeyで facetCondition (FilterCondition[FacetKey]) に
 * 返り値の operator でアクセスする場合、型エラーが発生するので、
 * 利用側で型アサーション(as keyof facetCondition) を行うようにする
 */
export const getPreferredFacetConditionOperator = (facetKey: FacetKey) =>
  PREFERRED_OPERATORS[facetKey];

export function getFacetConditionValues<
  K extends FacetKey,
  O extends AllowedFacetConditionOperator<K>,
>(facetKey: K, operator: O, filterCondition: FilterCondition) {
  const facetCondition = filterCondition[facetKey] as Partial<
    Record<O, string[]>
  >;

  return facetCondition?.[operator] ?? [];
}
